function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    position: "absolute",
    backgroundColor: theme.palette.background.default,
    zIndex: 1,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    overflow: "hidden"
  }
}));

const AppBase = (_ref) => {
  let children = _ref.children,
      theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "theme"]);

  const classes = useStyles();
  return React.createElement("main", {
    className: classes.root
  }, children);
};

export default AppBase;